import { render } from "./EmpresaEdit.vue?vue&type=template&id=7f1462c0&scoped=true"
import script from "./EmpresaEdit.vue?vue&type=script&lang=js"
export * from "./EmpresaEdit.vue?vue&type=script&lang=js"

import "./EmpresaEdit.vue?vue&type=style&index=0&id=7f1462c0&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1462c0"]])

export default __exports__